<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Resposta chamado"
             col-md="col-md-3" offset="offset-3">
    <template v-slot:modalContent>
      <form ref="cadastroForm" @submit.prevent="submitIncluirForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="resposta" v-model="dado.resposta" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('resposta')" autofocus/>
                <label for="resposta"><strong>Resposta: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6" v-if="!clienteLogado">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.status"
                    inputId="status"
                    :options="novoStatus"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('status')"
                />
                <label for="status">
                  <strong>Novo Status: <span class="text-danger font-bold">*</span></strong>
                </label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fecharSubModal')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";
import moment from "moment/moment";


export default {
  name: "CadastrarRespostaCrm",
  components: {
    BaseModal,
  },
  props: {
    itemSelect: Number,
  },
  data() {
    return {
      dado: {
        chamados: this.itemSelect,
        resposta: "",
        status: "",
        cliente_logado: localStorage.getItem('crm_clienteLogado'),
      },
      clienteLogado: localStorage.getItem('crm_clienteLogado'),
      campoVazio: [],
      novoStatus: [
        {label: 'ABERTO', value: 'A'},
        {label: 'FINALIZADO', value: 'F'},
        {label: 'NÃO PROCEDENTE', value: 'N'},
        {label: 'PENDENTE', value: 'P'},
      ],
    }
  },
  emits: ["fecharSubModal", "atualizarRespostas", "statusAtualizado"],
  methods: {
    async submitIncluirForm() {
      const resultado = await apiRequest("POST", apiUrl.crm.createListResposta, this.dado);
      if (resultado.success) {
        ['data_cadastro'].forEach(field => {
          resultado.data[field] = moment(resultado.data[field]).format('DD/MM/YYYY H:mm')
        });
        this.$emit("atualizarRespostas", resultado.data);
        if (this.dado.status === 'A') {
          this.dado.status = '<span class="text-success font-bold"> ABERTO </span>';
        }
        if (this.dado.status === 'F') {
          this.dado.status = '<span class="font-bold" style="color: #19bd04"> FINALIZADO </span';
        }
        if (this.dado.status === 'N') {
          this.dado.status = '<span class="text-danger font-bold"> NÃO PROCEDENTE </span>';
        }
        if (this.dado.status === 'P') {
          this.dado.status = '<span class="text-warning font-bold"> PENDENTE </span>';
        }

        this.$emit("statusAtualizado", {
          id: this.dado.chamados,
          status: this.dado.status
        });
        this.$toastMessage("success", "Registro salvo com sucesso!");
        this.$emit('fecharSubModal');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    }
  },
}
</script>
